module.exports = __webpack_public_path__ + "static/Industrial Lunch Truck Specs FL, NY, IL, CO 2026-571b08974ab8b651092014eb5c27586b.pdf";